import React, { useMemo, useState } from "react";
import { endemicity } from "../assets/ethiopia-data/prevalence_endemicity/endemicity";
import { IoIosInformationCircle } from "react-icons/io";
import { IoCaretBack } from "react-icons/io5";
const EndemicityLevels = ({
  selectedRegionalState,
  selectedZone,
  selectedWoreda,
  selectedKebele,
}) => {
  const [modal, setModal] = useState(false);

  const toggleLegendBox = () => {
    setModal((prev) => !prev);
  };

  const matchedRecord = useMemo(() => {
    if (!endemicity) return null;

    return endemicity.find((item) => {
      return (
        item["IU name"] === selectedKebele ||
        item["IU name"] === selectedWoreda ||
        item["IU name"] === selectedZone ||
        item["IU name"] === selectedRegionalState
      );
    });
  }, [selectedRegionalState, selectedZone, selectedWoreda, selectedKebele]);

  if (!matchedRecord) return null;

  const categoryColors = {
    "1 - 9.9% post-IA prevalence": "#91cf60",
    "<1% prevalence (non-endemic)": "#1a9850",
    "10 - 49.9% post-IA prevalence": "#fc8d59",
    ">=50% post-IA prevalence": "#d73027",
    "1 - 9.9% prevalence (low)": "#91cf60",
    "Surveillance (prevalence <1%)": "#74add1",
    "10 - 49.9% prevalence (moderate)": "#fc8d59",
    ">=50% prevalence (high)": "#d73027",
    "Endemicity unknown": "#999999",
    "No data available": "#cccccc",
  };

  const category = matchedRecord["Category"];
  const color = categoryColors[category] || "black";

  return (
    <div
      style={{
        position: "absolute",
        right: "9px",
        top: "9px",
        background: "white",
        padding: "10px 14px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 1200,
        minWidth: "240px",
      }}
    >
      {/* Header */}
      <p
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          margin:"0px",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Risk
        {modal ? (
          <IoCaretBack
            onClick={toggleLegendBox}
            style={{ cursor: "pointer", fontSize: "20px", marginLeft: "6px" }}
            title="Show back"
          />
        ) : (
          <IoIosInformationCircle
            onClick={toggleLegendBox}
            style={{ cursor: "pointer", fontSize: "20px", marginLeft: "6px" }}
            title="Show legend"
          />
        )}
      </p>

      {/* Location */}
      <p style={{ margin: "4px 0" ,fontSize: "14px"}}>
        <b>Location:</b> {matchedRecord["IU name"]}
      </p>

      {/* Category */}
      <p style={{ margin: "4px 0",fontSize: "14px"}}>
        <b>Category:</b>{" "}
        <span style={{ fontWeight: "600", color }}>{category}</span>
      </p>

      {/* Legend Box */}
      {modal && (
        <div
          style={{
            marginTop: "12px",
            padding: "8px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            background: "#fafafa",
          }}
        >
          <p
            style={{ margin: "0 0 6px 0", fontSize: "16px", fontWeight: "600" }}
          >
            Category Info
          </p>
          {Object.entries(categoryColors).map(([key, color]) => (
            <div
              key={key}
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: "14px",
                  height: "14px",
                  backgroundColor: color,
                  borderRadius: "3px",
                  marginRight: "8px",
                }}
              ></span>
              {key}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EndemicityLevels;
